module.exports = __webpack_public_path__ + "school/img/chuanCategoryBg.8e076a33.jpg";